import * as React from "react";
import { Button} from "antd";
import { connect } from "react-redux";


interface IPublicProps {
  id:any;
  submitTag:any;
  name:any;
  tag:any;
  tagid:any;
  getOrderDetails:any;
}

class Public extends React.Component<IPublicProps, any> {
  state = {
    visible:false,
    content:'',
  };
  constructor(props: IPublicProps) {
    super(props);
  }

  submitTag = () =>{
    let type = '';
    if(this.props.name == '加急'){
        type = 'urgent';
    }
    if(this.props.name == '占位'){
      type = 'occupying';
    }
    if(this.props.name == '关闭'){
      type = 'guan';
    }
    if(this.props.name == '打包'){
      type = 'bao';
    }
    if(this.props.name == '群'){
      type = 'qun';
    }
    if(this.props.name == '发'){
      type = 'fa';
    }
    const param: any = {
      id: this.props.id,
      type : type
    }; 
    this.props.submitTag({
      ...param,
      callback: (data) => {
        const params: any = {
          id: this.props.id
        }; 
        this.props.getOrderDetails({
          ...params,
          callback: () => {
            console.log(this.props);
          }
         });
      }
     }); 
  }
  render() {
    const buttonStyle = {
      backgroundColor: "#fff",
      color:"#000",
      border:'none',
      display: 'block',
    };
    return (
      <React.Fragment>
      {this.props.tag.indexOf(this.props.tagid) ? <Button style={buttonStyle} onClick={this.submitTag}>{this.props.name}</Button>:''} 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    submitTag:dispatch.orderDetails.submitTag,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Public);
